import { render, staticRenderFns } from "./HouseholdInformation.vue?vue&type=template&id=369979dc&scoped=true&"
import script from "./HouseholdInformation.vue?vue&type=script&lang=ts&"
export * from "./HouseholdInformation.vue?vue&type=script&lang=ts&"
import style0 from "./HouseholdInformation.vue?vue&type=style&index=0&id=369979dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369979dc",
  null
  
)

export default component.exports